import { render, staticRenderFns } from "./PaymentTypesBase.vue?vue&type=template&id=da020fb4&scoped=true&"
import script from "./PaymentTypesBase.vue?vue&type=script&lang=ts&"
export * from "./PaymentTypesBase.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da020fb4",
  null
  
)

export default component.exports